const TrackingEventSearchModuleConstants = {
    rootStateName: "trackingEventSearch",
    prevStateLabel: "tracking-event-search",
    pageTitlePrefix: "TrackerBase Event Search"
};

export default Object.freeze(TrackingEventSearchModuleConstants);



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-search/Constants.js
// module id = K3cs
// module chunks = 1